<template>
  <div class="column">
    <default-radio :value="selectedValue" :val="value" v-on="$listeners" :font-size="fontSize" button-size="sm" dense>
      <r-icon :name="icon"/>
    </default-radio>
    <div :style="labelStyle" :class="selectedClass"> {{ label }} </div>
  </div>
</template>

<script>
import RIcon from '@/components/base/RIcon';
import DefaultRadio from '@/components/styled/DefaultRadio';

export default {
  name: 'RichRadioButton',
  components: { DefaultRadio, RIcon },
  props: {
    selectedValue: {
      type: String,
    },
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    icon: {
      type: String,
      required: true,
    },
    fontSize: String,
  },
  computed: {
    labelStyle() {
      return { fontSize: this.fontSize };
    },
    selectedClass() {
      if (this.value === this.selectedValue) {
        return ['text-riseup-blue', 'r-text-bold'];
      }
      return [];
    },
  },
};
</script>
